/**
 * Shared Tailwind class strings for inline forms. The input and label classes
 * match CustomerFormPage.
 */

export const inputClass =
  'block w-full rounded-lg border border-gray-300 bg-white px-3.5 py-2.5 text-gray-900 shadow-sm ' +
  'placeholder:text-gray-400 transition duration-150 ' +
  'hover:border-gray-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20 ' +
  'disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500';

export const labelClass = 'block text-sm font-medium text-gray-700 mb-1.5';

export const primaryButtonClass =
  'bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white text-sm font-semibold py-2 px-4 min-h-[44px] sm:min-h-0 rounded-md transition duration-200';

export const secondaryButtonClass =
  'py-2 px-4 min-h-[44px] sm:min-h-0 rounded-md border border-gray-300 bg-white text-sm font-semibold text-gray-700 hover:bg-gray-50 ' +
  'disabled:opacity-50 disabled:cursor-not-allowed transition duration-200';

export const rowActionClass =
  'py-2.5 px-2 sm:p-0 text-sm font-semibold text-blue-600 hover:text-blue-700 disabled:text-gray-400 disabled:cursor-not-allowed';

export const rowDangerActionClass =
  'py-2.5 px-2 sm:p-0 text-sm font-semibold text-red-600 hover:text-red-700 disabled:text-gray-400 disabled:cursor-not-allowed';
